module.exports = __webpack_public_path__ + "42aeb2182916e314419e581edbc30dcd.MP3";